import { PERSONAL_API_URL } from '@/shared/lib/const/env'

export { API_URL, BASE_URL, FILES_URL, PERSONAL_API_URL } from '@/shared/lib/const/env'

// Prefix before id in detailed product page url
export const PRODUCT_ID_URL_PREFIX = `productID`
export const PRODUCT_URL = `/products/${PRODUCT_ID_URL_PREFIX}`
export const PRODUCT_IMAGE_PLACEHOLDER = `/product-image-placeholder.jpeg`
export const PERSONAL_API = PERSONAL_API_URL + `/api`
export const FILTER_URL = `filter`
export const ACCESSORIES_ID = `365`
export const LSSessionCountName = `openPageList`
export const B2B_SCRIPT_ID = `480079`
export const DOMAIN_URL = `iport.ru`
export const DOMAIN = `iport`
export const SPB_CITY_CODE = `spb`
export const SPB_CITY_NAME = '\u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433'
export const CREDIT_ODD = 0.0359
export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_KEY
export const sitemapExcluded = {
	excluded: [
		`promo/lottery/`,
		`promo/mac-gift/`,
		`promo/geo1000/`,
		`promo/mac/`,
		`brand/[brand]`,
		`love_season/`,
		`check/`,
		`promo/apple-watch-2023/`,
		`promo/backtoschool2024/`,
		`promo/iphone-15/`,
		`promo/iphone-16e/`,
		`services/applecare-plus/`,
		`services/applecare-plus/airpods/`,
		`services/applecare-plus/appletv/`,
		`services/applecare-plus/display/`,
		`services/applecare-plus/ipad/`,
		`services/applecare-plus/iphone/`,
		`services/applecare-plus/ipod/`,
		`services/applecare-plus/mac/`,
		`services/applecare-plus/watch/`,
		`gifts/`,
		`service/credit/t-bank/`,
		`services/limits/`,
		`compare/`,
		`cart/`,
		`enter/`,
		`favorites/`,
		`new/`,
		`new-year/`,
		`school/`,
		`space/`,
		`split/`,
		`sber/fail/`,
		`order/`,
		`order/[productIds]/`,
		`order/error/failed-loading-info/`,
		`order/error/failed-to-order/`,
		`personal/profile/`,
		`personal/orders/`,
		`personal/bonuses/`,
		`personal/limit/`,
		`personal/companies/`,
		`order/success/[transactionId]/`,
		`personal/companies/new/`,
		`personal/`,
		`personal/tools/`
	],
	specific: [
		`pages/catalog`,
		`pages/promo/study`,
		`pages/promo/1111`,
		`pages/promo/black`,
		`pages/promo/july-vibe`,
		`pages/promo/bonuses`,
		`pages/promo/visionpro`,
		`pages/promo/iphone_16`,
		`pages/order`,
		`pages/personal`,
		`pages/compare`,
		`pages/cart`,
		`pages/enter`,
		`pages/favorites`,
		`pages/new`,
		`pages/gifts`
	]
}
